import { HubConnection, HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr';
import { Injectable, signal } from '@angular/core';

import { environment } from '@env/environment';
import { TokenService } from './token.service';

@Injectable({ providedIn: 'root' })
export class SignalRService {
  private connection: HubConnection | null = null;

  readonly isConnected = signal(false);

  constructor(private readonly tokenService: TokenService) {}

  async connect(): Promise<void> {
    if (!this.connection) {
      const token = this.tokenService.getAccessToken();
      const url = `${environment.apiUrl}smsHub?token=${token}&clientVersion=${environment.appVersion}`;

      this.connection = new HubConnectionBuilder()
        .withUrl(url, {
          headers: {
            'X-Client-Version': environment.appVersion,
          },
        })
        .withAutomaticReconnect()
        .build();

      this.connection.serverTimeoutInMilliseconds = 90_000;
      this.connection.keepAliveIntervalInMilliseconds = 20_000;
    }

    if (this.connection.state === HubConnectionState.Connected) {
      return;
    }

    await this.connection.start();
    this.isConnected.set(true);
  }

  async disconnect(): Promise<void> {
    if (this.connection) {
      await this.connection.stop();
      this.isConnected.set(false);
    }
  }

  on(methodName: string, callback: (...args: unknown[]) => void): void {
    this.connection?.on(methodName, callback);
  }

  onReconnecting(callback: (error?: Error) => void): void {
    this.connection?.onreconnecting(callback);
  }

  onClose(callback: (error?: Error) => void): void {
    this.connection?.onclose(callback);
  }
}
